// extracted by mini-css-extract-plugin
export default {"body":"Profile_body__52O-Z","profilePhoto":"Profile_profilePhoto__LSYEw"};